<!--

Basic Creek Chat Room

Client

Requires Vue.js

-->
<template>

<div id="Creek-Chat" class="creek-chat" :class="{ 'creek-chat-open': windowOpen ? true : false, 'creek-chat-closed': windowOpen ? false : true }">

  <div class="creek-chat-inner-open">
    
    <div class="creek-chat-messages-container">
      <ul class="creek-chat-messages">
        <li v-for="message in messages">
          <span v-if="message.type=='message'" class="creek-chat-message-username" v-text="message.username"></span>
          <span :class="'creek-chat-message-type-'+message.type" v-text="message.content"></span>
          <span class="creek-chat-message-time" v-text="message.timestampFormatted"></span>
        </li>
      </ul>
      <ul class="creek-chat-messages-typing">
        <li v-for="typing in usersTyping">
          <span v-text="typing.username"></span> is typing.
        </li>
      </ul>
    </div>

    <div class="creek-chat-username-container" v-if="user.anonymous">
      <h3 v-html="l.startWithName"></h3>
      <input class="creek-chat-username-input" @keyup.enter="editUsername" type="text" maxlength="14" :placeholder="l.startWithNameInputPlaceholder" v-model="inputUsername" />
    </div>

    <div class="creek-chat-input-container">
      <input class="creek-chat-message-input" v-model="messageInput" @keyup.enter="messageSend" :placeholder="l.chatInputPlaceholder"/>
    </div>

    <div class="creek-chat-users-container">
      <a class="creek-chat-exit" href="javascript:" @click="toggleChatOpen()"><i class="fa fa-close fa-lg"></i> Exit Chat</a>
      <h2><span v-text="userCount"></span> user<span v-text="userCount > 1 ? 's' : ''"></span>.</h2>
      <div class="creek-chat-username">
        <input class="creek-chat-username-input" @keyup.enter="editUsername" type="text" maxlength="14" placeholder="Change username..." v-model="inputUsername" />
      </div>
      <ul class="creek-chat-users">
        <li v-for="user in users" v-text="user.username"></li>
      </ul>
    </div>
    
  </div>

  <a class="creek-chat-inner-closed" @click="toggleChatOpen()" href="javascript:">
    <i class="fa fa-comment-o fa-lg"></i>
    <span v-text="userCount ? userCount : '1'"></span> user<span v-text="userCount > 1 ? 's' : ''"></span> in chat.
  </a>

</div>

</template>


<script>

var moment = require('moment');

export default {

  props: [
    'stationId', 'socketAddress', 'debugEnabled',
    'lang'
  ],

  data () {

    return {

      user: {
        
        username: "",

        //Users start out as anonymous
        anonymous: true

      },

      chatSocket: {},

      messages: [],
      users: [],
      usersTyping: [],
      
      connected: false,

      messageInput: "",
      messageLastSent: '',

      inputUsername: "",

      windowOpen: false,

      langDefaults: {
        startWithName: "Type your name and press enter to start chat.",
        startWithNameInputPlaceholder: "Type your name...",
        chatInputPlaceholder: "Type here...",
        users: "users"
      }

    };

  },

  methods: {

    debug (logOutput) {
      if(this.debugEnabled) {
        console.log("Creek Chat: "+logOutput);
      }
    },

    editUsername (username) {

      // var $ = require('jquery');

      var newUsername = this.cleanInput(this.inputUsername);
      
      this.debug("Updating username.");

      // If the username is valid
      if (this.user.username) {

        this.debug("Done updating username.");

        this.user.username = newUsername;

        //User is no longer anonymous
        this.user.anonymous = false;
        
        $(".creek-chat-message-input").focus();

        // Tell the server your username
        this.chatSocket.emit('edit username', this.user.username);
      
        this.inputUsername = '';

      }

    },
    
    messageSend () {
      
      this.stopTyping();

      var message = this.messageInput;

      // Prevent markup from being injected into the message
      message = this.cleanInput(message);

      this.debug("Attempting to send: " + message);

      // Only send if there is a non-empty message and a socket connection
      if (message && this.connected) {

        this.chatSocket.emit('send message', this.messageInput);

        this.debug("Message: " + this.user.username + ": " + this.messageInput);

        this.messageLastSent = this.messageInput + "";

        this.messageInput = '';

      }

    },
    
    updateMessages (messages) {
      this.messages = messages;
    },
    
    updateUsers (users) {
      this.users = users;
    },

    updateTyping (usersTyping) {
      this.usersTyping = usersTyping;
    },
    
    startTyping () {
      this.chatSocket.emit('start typing');
    },

    stopTyping () {
      this.chatSocket.emit('stop typing');
    },

    // Scrolls to the bottom of the chat window (used on new messages)
    scrollChatWindow () {

      // var $ = require('jquery');

      $('.creek-chat-messages-container').each(function() {
        var scrollHeight = $(".creek-chat-messages").outerHeight();
        $(this).scrollTop(scrollHeight);
        $(this).scrollTop = scrollHeight;
      });

    },

    // Scrolls to the bottom of the chat window (used on new messages)
    scrollChatWindowAnimate () {

      // var $ = require('jquery');
      
      $('.creek-chat-messages-container').each(function() {
        var scrollHeight = $(".creek-chat-messages").outerHeight();
        $(this).animate({scrollTop: scrollHeight+"px"});
      });

    },

    // Prevents input from having injected markup
    cleanInput (input) {
      return $('<div/>').text(input).text();
    },

    logMessage (log) {
      this.debug("Chat message: "+log);
      this.messages.push({
        type: "info",
        username: this.user.username,
        content: log
      })
    },

    toggleChatOpen () {
      this.windowOpen = this.windowOpen ? false : true;
    },


    //------------------------------------------
    // Socket methods
    //------------------------------------------

    socket_connected () {
      this.connected = true;
      this.chatSocket.emit('set station', this.stationId);
      this.logMessage('Welcome.');
    },
 
    socket_disconnect () {
      this.connected = false;
      this.logMessage('You have been disconnected.');
    },

    socket_reconnect () {
      if (this.user.username) {
        this.chatSocket.emit('add user', this.user.username);
      }
      this.logMessage('You have been reconnected.');
    },

    socket_reconnect_error () {
      this.logMessage('Attempt to reconnect has failed.');
    },

    // Update current username
    socket_updateUsername (username) {
      this.user.username = username;
    },

    // Update the user list
    socket_updateUsers (users) {
      this.users = users;
    },

    formatMessage (message) {

      //Format the timestamp
      message.timestampFormatted = moment(message.timestamp).format("HH:mm, MMM DD");
    
      return message;

    },

    // Add a single new array element to messages
    socket_addMessage (data) {

      data = this.formatMessage(data);

      var this_this = this;

      this.messages.push(data);
      
      setTimeout(function() {
        this_this.scrollChatWindowAnimate();
      }, 100);
    
      setTimeout(function() {
        this_this.scrollChatWindowAnimate();
      }, 200);
    
    },

    // Add a single new array element to messages
    socket_addInitialMessage (data) {

      var this_this = this;
      
      data = this.formatMessage(data);

      this.messages.push(data);
      
      setTimeout(function() {
        this_this.scrollChatWindow();
      }, 100);
      
      setTimeout(function() {
        this_this.scrollChatWindow();
      }, 200);
    
    },

    // Update the chat body
    socket_updateMessages (data) {

      //Format messages (add timestamps)
      for (var d = 0; d < data.length; d++) {
        data2.push(this.formatMessage(data[d]));
      }

      this.messages = data2;

      this.scrollChatWindow();

    },

    // Update the typing message
    socket_updateTyping (usersTyping) {
      this.usersTyping = usersTyping;
      this.scrollChatWindow();
    },

  },
  computed: {

    l () {

      var o = Object.assign(this.langDefaults, this.lang);

      return o;

    },

    // Gets the color of a username through a hash function
    usernameColor () {
      var usernameColors = [
        '#e21400', '#91580f', '#f8a700', '#f78b00',
        '#58dc00', '#287b00', '#a8f07a', '#4ae8c4',
        '#3b88eb', '#3824aa', '#a700ff', '#d300e7'
      ];
      // Compute hash code
      var hash = 7;
      for (var i = 0; i < this.user.username.length; i++) {
         hash = this.user.username.charCodeAt(i) + (hash << 5) - hash;
      }
      // Calculate color
      var index = Math.abs(hash % usernameColors.length);
      return usernameColors[index];
    },

    userCount () {
      return Object.keys(this.users).length;
    },

    isTyping () {
      if(this.messageLastSent != this.messageInput) {
        return true;
      }else{
        return false;
      }
    },

    chatSocketAddress () {
      if(this.socketAddress) {
        return this.socketAddress;
      }
      else {
        return "http://one.h.creek.fm:3000";
      }
    }

  },
  created () {
      
    this.debug("Chat initialized.");
    this.debug("Connecting to Chat server at: "+this.chatSocketAddress);

    var this_this = this;

    this.scrollChatWindow();

    var s = require('socket.io-client')(this.chatSocketAddress);

    this.chatSocket = s;

    s.on("connected", function() {
      this_this.socket_connected();
    })

    s.on("disconnect", function() {
      this_this.socket_disconnect();
    })

    s.on("reconnect", function() {
      this_this.socket_reconnect();
    })

    s.on("reconnect_error", function() {
      this_this.socket_reconnect_error();
    })
    
    s.on("update username", function(username) {
      this_this.socket_updateUsername(username);
    });

    s.on("update users", function(users) {
      this_this.socket_updateUsers(users);
    });

    s.on("add message", function(data) {
      this_this.socket_addMessage(data);
    });

    s.on("add initial message", function(data) {
      this_this.socket_addInitialMessage(data);
    });

    s.on("update messages", function(data) {
      this_this.socket_updateMessages(data);
    });

    s.on("update typing", function(usersTyping) {
      this_this.socket_updateTyping(usersTyping);
    });

  },
  // updated (done) {
  //   this.scrollChatWindow();
  //   this.debug("Window updated.");
  //   // var el = document.getElementById(chatWindow);
  //   // el.scrollTop = el.scrollHeight;
  //   done();
  // }
}

</script>


<style>

.creek-chat ul {
  list-style: none;
  word-wrap: break-word;
  margin: 0;
  padding: 0;
}

.creek-chat li {
  padding: 0;  
  margin: 0;
}

.creek-chat p, .creek-chat li, .creek-chat h2, .creek-chat h3, .creek-chat h4 {
  color: #fff;
}

.creek-chat input {
  color: #fff;
  padding: 6px 10px;
  font-size: 16px;
  background: transparent;
  border: 2px solid #fff;
}

.creek-chat.creek-chat-open {
  position: fixed;
  height: 100%;
  width: 100%;
  /*margin: 30px;*/
  border: 5px solid #fff;
  box-sizing: border-box;
  z-index: 999;
  top: 0;
  left: 0;
  background:#000;
}

.creek-chat.creek-chat-closed {
  position: fixed;
  /*margin: 30px;*/
  /*border: 3px solid #fff;*/
  padding:10px;
  z-index: 999;
  bottom: 0;
  left: 20px;
  background:#fff;
  color: #000;
  border: 3px solid #000;
  border-bottom: 0;
}
.creek-chat a.creek-chat-inner-closed {
  color: #000;
}

.creek-chat.creek-chat-closed .creek-chat-inner-open {
  display:none;
}
.creek-chat.creek-chat-closed .creek-chat-inner-closed {
  display:block;
}
.creek-chat.creek-chat-open .creek-chat-inner-open {
  display:block;
  position: absolute;
  height: 100%;
  width: 100%;
}
.creek-chat.creek-chat-open .creek-chat-inner-closed {
  display:none;
}

.creek-chat-messages-container {
  /*padding: 20px;*/
  position: absolute;
  height: 100%;
  width: 78%;
  overflow: auto;
}

.creek-chat-username-container {
  position: fixed;
  width: 100%;
  box-sizing: border-box;
  z-index: 10000;
  left: 0;
  bottom: 0;
  background:#fff;
  color: #000;
  padding: 20px 16px 20px 20px;
}

.creek-chat-username-container input {
  width: 100%;
  border:0;
  border-bottom: 3px solid #000;
  box-sizing: border-box;
  background:#fff;
  transition: all 0.5s;
  padding: 8px 0px;
  /*padding: 8px 2px;*/
  font-size: 16px;
  color: #000;
}
.creek-chat-username-container input:focus {
  outline: none;
  /*background: #000;*/
  transition: all 0.5s;
}
.creek-chat-username-container h3 {
  color: #000;
  margin: 0 0 10px 0;
  padding: 0;
  font-size: 20px;
}

.creek-chat-input-container {
  position: absolute;
  overflow: auto;
  bottom: 0;
  left:0;
  width: 100%;
  background: #000;
}

.creek-chat-input-container input {
  padding: 20px;
  display:block;
  width:100%;
  border: 0;
  border-top: 3px solid #fff;
  box-sizing: border-box;
  background: #000;
}

.creek-chat-messages {
  padding: 20px 20px 80px 20px !important;
}

.creek-chat-messages li {
  padding: 4px 6px;
  line-height: 125%;
  overflow: auto;
}

.creek-chat-messages li:hover {
  background: rgba(255,255,255,0.1);
}
.creek-chat-messages li:hover .creek-chat-message-time {
  color: rgba(255,255,255,.8);
}

.creek-chat-username {
  margin: 10px 0;
}

.creek-chat-username-input {
  display:block;
  width:90%;
  box-sizing: border-box;
  background: #000;
  margin-right: 10px;
  /*border-right: 0;*/
}

.creek-chat-message-username {
  font-weight: 600;
  color: #fff;
  margin-right: 4px;
}

.creek-chat-message-time {
  font-weight: 400;
  font-size: 14px;
  color: rgba(255,255,255,.2);
  margin-left: 4px;
  float: right;
}

.creek-chat-message-type-info {
  color: #999;
}

.creek-chat-message-type-message {
  font-weight: 300;
  color: #ccc;
}

.creek-chat-users-container {
  position: absolute;
  top: 0; 
  left: 80%;
  width: 20%;
  height: 100%;
}
.creek-chat-users-container li {
  margin-bottom: 4px;
}

.creek-chat-exit {
  background: #fff;
  padding: 10px 14px;
  color:#000;
  display:block;
  /*text-decoration: underline;*/
  font-size: 18px;
  text-transform: uppercase;
}

</style>


// WEBPACK FOOTER //
// CreekChat.vue?034e600a